import React from 'react';

import {Navigate} from 'react-router-dom';

import {useDispatch, useSelector} from 'react-redux';

import {signinOptionsSelector} from '../selectors';

export const IndexPage = () => {
    const dispatch = useDispatch();

    const options = useSelector((state) => signinOptionsSelector(state));

    if (Array.isArray(options) && options.length > 0) {
        const firstOptionId = options[0].id;
        return <Navigate to={`/signin-options/${firstOptionId}`} />;
    }
    return <Navigate to="/signin-options/add" />;
};
